(function () {
  // The two for 15% offer applies to the drying robe only.
  function onRobePage() {
    return location.pathname.indexOf('/products/the-drying-robe') !== -1;
  }

  var CSS = [
    '.fid-bundle{margin:-6px 0 6px}',
    '.fid-bd{display:flex;align-items:center;gap:12px;padding:13px 15px;border:1px dashed rgba(189,115,56,.6);border-radius:12px;background:#faf7f1;cursor:pointer;transition:border-color .15s ease,background .15s ease}',
    '.fid-bd:hover{border-color:#bd7338}',
    '.fid-bd:has(.fid-bd-i:checked){background:#f1efe8;border-style:solid;border-color:#2f4a36}',
    '.fid-bd .fid-bd-i{position:absolute;opacity:0;width:0;height:0;pointer-events:none}',
    '.fid-bd-box{position:relative;flex:0 0 20px;width:20px;height:20px;border-radius:6px;border:2px solid #bd7338;background:#fff;box-sizing:border-box;transition:background .15s ease,border-color .15s ease}',
    '.fid-bd-i:checked+.fid-bd-box{background:#2f4a36;border-color:#2f4a36}',
    '.fid-bd-i:checked+.fid-bd-box::after{content:"";position:absolute;left:5px;top:1.5px;width:5px;height:10px;border:solid #fdfbf7;border-width:0 2px 2px 0;transform:rotate(45deg)}',
    '.fid-bd-i:focus-visible+.fid-bd-box{outline:2px solid #2f4a36;outline-offset:2px}',
    '.fid-bd-txt{display:flex;flex-direction:column;gap:2px;flex:1 1 auto;min-width:0}',
    '.fid-bd-txt strong{font-size:14px;font-weight:600;line-height:1.25;color:#33261c}',
    '.fid-bd-txt span{font-size:12px;line-height:1.3;color:#7a6a5c}',
    '.fid-bd-pill{flex:0 0 auto;padding:5px 11px;border-radius:999px;background:#2f4a36;color:#fdfbf7;font-size:12px;font-weight:600;letter-spacing:.03em;white-space:nowrap}',
    '@media(max-width:749px){.fid-bd{padding:12px 13px;gap:10px}.fid-bd-txt strong{font-size:13px}.fid-bd-txt span{font-size:11.5px}.fid-bd-pill{font-size:11px;padding:4px 9px}}'
  ].join('');

  var MARKUP =
    '<label class="fid-bd">' +
      '<input type="checkbox" class="fid-bd-i">' +
      '<span class="fid-bd-box" aria-hidden="true"></span>' +
      '<span class="fid-bd-txt">' +
        '<strong>Two dogs? Add a second robe</strong>' +
        '<span>15% comes off both, applied automatically at checkout</span>' +
      '</span>' +
      '<span class="fid-bd-pill">Save 15%</span>' +
    '</label>';

  function injectStyle() {
    if (document.getElementById('fid-bundle-css')) return;
    var s = document.createElement('style');
    s.id = 'fid-bundle-css';
    s.textContent = CSS;
    document.head.appendChild(s);
  }

  function mount() {
    if (!onRobePage()) return;
    if (document.querySelector('.fid-bundle')) return;
    var anchor = document.querySelector('.fid-trust');
    if (!anchor) return;
    var host = anchor.parentElement;
    if (!host || !host.parentElement) return;
    var wrap = document.createElement('div');
    wrap.className = 'fid-bundle';
    wrap.innerHTML = MARKUP;
    host.insertAdjacentElement('beforebegin', wrap);
    var cb = wrap.querySelector('.fid-bd-i');
    var q = document.querySelector('input[name=quantity]');
    if (q && parseInt(q.value, 10) > 1) cb.checked = true;
    cb.addEventListener('change', function () {
      var qty = document.querySelector('input[name=quantity]');
      if (!qty) return;
      qty.value = cb.checked ? 2 : 1;
      qty.dispatchEvent(new Event('input', { bubbles: true }));
      qty.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  function boot() {
    if (!onRobePage()) return;
    injectStyle();
    mount();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  var t;
  new MutationObserver(function () {
    clearTimeout(t);
    t = setTimeout(mount, 60);
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
